if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
 
        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }
 
      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';
 
        if (preventFocus) this.openedBy = null;
        super.hide();
      }
 
      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');
 
        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');
 
            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
 
            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();
 
            // Hide modal content until Swiper is ready
            this.modalContent.style.opacity = '0';
            this.modalContent.querySelector('product-component')?.dispatchViewEvent?.();
 
            super.show(opener);
 
            // Init Swiper, then reveal modal once fully ready
            initCustomSwiperInModal(() => {
              this.modalContent.getBoundingClientRect(); // force reflow
              this.modalContent.style.transition = 'opacity 0.15s ease';
              this.modalContent.style.opacity = '1';
            });
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }
 
      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }
 
      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }
 
      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();
 
        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();
 
        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }
 
      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;
 
        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });
 
        productElement.dataset.originalSection = sectionId;
      }
 
      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;
 
        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }
 
      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;
 
        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;
 
        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
 
        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }
 
        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
 
// ---------------------------------------------------------------------------
// Swiper initialisation for Quick Add modal
// ---------------------------------------------------------------------------
 
function initCustomSwiperInModal(onReady) {
  const productGallery = document.querySelector('[id^="Slider-Gallery-quickadd"]');
 
  if (!productGallery) {
    console.warn('⚠️ No product gallery found in modal');
    if (onReady) onReady();
    return;
  }
 
  const slides = productGallery.querySelectorAll('[id^="Slide-"] img');
  const imageUrls = [...slides].map((img) => img.getAttribute('src')).filter(Boolean);
 
  if (imageUrls.length === 0) {
    console.warn('⚠️ No images found in gallery');
    if (onReady) onReady();
    return;
  }
 
  // Build Swiper markup
  const swiperContainer = document.createElement('div');
  swiperContainer.className = 'swiper myProductSwiper';
  swiperContainer.innerHTML = `
    <div class="swiper-wrapper">
      ${imageUrls
        .map(
          (url, i) => `
          <div class="swiper-slide">
            <img src="${url}" alt="Product Image ${i + 1}" loading="eager">
          </div>`
        )
        .join('')}
    </div>
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
  `;
 
  // Only insert if not already present
  const galleryViewer = document.querySelector('slider-component[id^="GalleryViewer-quickadd-"]');
  if (galleryViewer && !galleryViewer.querySelector('.myProductSwiper')) {
    productGallery.insertAdjacentElement('afterend', swiperContainer);
  }
 
  // Load Swiper assets then initialise
  loadSwiperAssets().then(() => {
    new Swiper('.myProductSwiper', {
      loop: true,
      slidesPerView: 2,
      spaceBetween: 20,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 2 },
      },
    });
 
    productGallery.classList.add('hide_gallery');
 
    // ✅ Swiper is fully ready — reveal the modal
    if (onReady) onReady();
  });
}
 
// Load Swiper CSS + JS only once
function loadSwiperAssets() {
  const cssHref = 'https://unpkg.com/swiper@9/swiper-bundle.min.css';
  const jsSrc = 'https://unpkg.com/swiper@9/swiper-bundle.min.js';
 
  return new Promise((resolve, reject) => {
    if (!document.querySelector(`link[href="${cssHref}"]`)) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = cssHref;
      document.head.appendChild(link);
    }
 
    if (window.Swiper) return resolve();
 
    const script = document.createElement('script');
    script.src = jsSrc;
    script.onload = resolve;
    script.onerror = reject;
    document.body.appendChild(script);
  });
}
/* ---- Quick View colour-swatch swap (reuses theme's own modal load) ---- */
(function () {
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.cstm-quick-drawer-swaches, .quick-drawer-swaches');
    if (!swatch) return;

    var modalEl = swatch.closest('quick-add-modal');
    if (!modalEl) return;

    var suburl = swatch.getAttribute('data-suburl');
    if (!suburl) return;

    e.preventDefault();
    e.stopPropagation();

    var modalContent = modalEl.modalContent || modalEl.querySelector('[id^="QuickAddInfo-"]');
    if (!modalContent) return;

    modalContent.style.opacity = '0.4';

    fetch(suburl)
      .then(function (response) { return response.text(); })
      .then(function (responseText) {
        var responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
        var productElement = responseHTML.querySelector('product-info');
        if (!productElement) { modalContent.style.opacity = ''; return; }

        // Run the modal's own preprocessing (dedupe IDs, fix images, etc.)
        if (typeof modalEl.preprocessHTML === 'function') {
          modalEl.preprocessHTML(productElement);
        }

        // Use the theme's HTML update util (same as first open)
        if (window.HTMLUpdateUtility && HTMLUpdateUtility.setInnerHTML) {
          HTMLUpdateUtility.setInnerHTML(modalContent, productElement.outerHTML);
        } else {
          modalContent.innerHTML = productElement.outerHTML;
        }

        if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();

        modalContent.style.opacity = '0';

        // Build the carousel, then reveal — exactly like first open
        initCustomSwiperInModal(function () {
          modalContent.getBoundingClientRect();
          modalContent.style.transition = 'opacity 0.15s ease';
          modalContent.style.opacity = '1';
        });
      })
      .catch(function () {
        modalContent.style.opacity = '';
      });
  }, false);
})();